import React from "react";
import { Phone, Mail, MapPin, ArrowUpRight } from "lucide-react";
import { siteInfo, brandLogos } from "../mock";

export default function Footer() {
  return (
    <footer className="bg-[#0a2a2e] text-white/80 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10 mb-14">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 rounded-xl bg-white/95 flex items-center justify-center p-1.5">
                <img src={brandLogos.cfmpe} alt="Logo CFMPE" className="w-full h-full object-contain" />
              </div>
              <div>
                <div className="font-display text-2xl text-white">{siteInfo.name}</div>
                <div className="text-[10px] uppercase tracking-widest text-white/50">Depuis 1996</div>
              </div>
            </div>
            <p className="text-sm text-white/60 leading-relaxed">
              Centre de formation aux métiers de la Petite Enfance à Nice.
              Sous contrôle pédagogique de l'État.
            </p>
          </div>

          {/* Nav */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Navigation</h4>
            <ul className="space-y-2.5 text-sm">
              {[
                ["Le Centre", "#le-centre"],
                ["CAP AEPE", "#cap-aepe"],
                ["Financements", "#financements"],
                ["Témoignages", "#temoignages"],
                ["Assistant IA", "#assistant"],
                ["Contact", "#contact"],
              ].map(([label, href]) => (
                <li key={href}>
                  <a href={href} className="hover:text-[#e8a04d] transition-colors inline-flex items-center gap-1 group">
                    {label}
                    <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Contact</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2.5">
                <MapPin className="w-4 h-4 mt-0.5 text-[#4ba9b0] flex-shrink-0" />
                <span>10 Avenue Georges Clemenceau, 06000 Nice</span>
              </li>
              <li className="flex items-center gap-2.5">
                <Phone className="w-4 h-4 text-[#4ba9b0] flex-shrink-0" />
                <a href={`tel:${siteInfo.phone.replace(/\./g,"")}`} className="hover:text-[#e8a04d] transition-colors">
                  {siteInfo.phone}
                </a>
              </li>
              <li className="flex items-center gap-2.5">
                <Mail className="w-4 h-4 text-[#4ba9b0] flex-shrink-0" />
                <a href={`mailto:${siteInfo.email}`} className="hover:text-[#e8a04d] transition-colors break-all">
                  {siteInfo.email}
                </a>
              </li>
            </ul>
          </div>

          {/* Certifications */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Certifications</h4>
            <div className="space-y-3">
              <div className="bg-white/5 border border-white/10 rounded-xl p-3 flex items-center gap-3">
                <img src={brandLogos.qualiopi} alt="Qualiopi" className="h-10 w-auto object-contain bg-white/95 rounded p-1" />
                <div>
                  <div className="font-semibold text-white text-sm">Qualiopi</div>
                  <div className="text-xs text-white/60">Processus certifié</div>
                </div>
              </div>
              <div className="bg-white/5 border border-white/10 rounded-xl p-3">
                <div className="font-semibold text-white text-sm">Rectorat de Nice</div>
                <div className="text-xs text-white/60">École déclarée</div>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/50">
          <div>© {new Date().getFullYear()} CFMPE — Tous droits réservés.</div>
          <div className="flex gap-6">
            <a href="#" className="hover:text-white transition-colors">Mentions légales</a>
            <a href="#" className="hover:text-white transition-colors">Politique de confidentialité</a>
            <a href="#" className="hover:text-white transition-colors">Règlement intérieur</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
